// extracted by mini-css-extract-plugin
export default {"closeButton":"modal-module--closeButton--1Uenc","right":"modal-module--right--z6xTE","left":"modal-module--left--1_YDm"};